<template>
  <section id="our-work" class="OurWork">
    <h2>Our Work</h2>
    <div class="section container">
      <vue-instagram token="10608144320.1677ed0.2188cfbc638f42df9900a6a0d859e6ee" :count="6" class="columns is-multiline is-mobile">
        <template slot="feeds" slot-scope="props">
          <div class="column is-4-desktop is-6-tablet is-12-mobile">
              <a :href="props.feed.link" target="_blank">
                <figure class="image is-square">
                    <img :src="props.feed.images.standard_resolution.url" alt="Image">
                </figure>
            </a>
          </div>
        </template>
      </vue-instagram>
    </div>
    <div class="panel" data-aos="fade-up-right"
    data-aos-offset="-500"
    data-aos-delay="0"
    data-aos-duration="1000"
    data-aos-easing="ease-in-out"
    data-aos-mirror="true"
    data-aos-once="false"
    data-aos-anchor-placement="top-center"></div>
  </section>
</template>
<script>

export default {
  name: 'OurWork',
  components: {
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
@import '../scss/colors.scss';

    .OurWork {
        padding: 75px 20px;
        
        a:hover {
            opacity: 0.8;
        }
        
        .panel {
            width: 100vw;
            height: 800px;
            position: absolute;
            background: -webkit-linear-gradient(to right, $white, $lightestGrey);
            background: -o-linear-gradient(to right, $white, $lightestGrey);
            background: -moz-linear-gradient(to right, $white, $lightestGrey);
            background: linear-gradient(to right, $white, $lightestGrey);
            z-index: -1;
            top: 200px;
            right: 0;
        }
    }
</style>
